import React from 'react'
import RectangleActionButton, { SIZE_BIG } from '../genericComponents/buttons/RectangleActionButton'
import { TAG_CLICK_USER_LOGIN_BUTTON } from '../analytics/analytics.tagids.constants'
import { withUserKnown } from './shared/withKeycloak'
import { useSelector } from 'react-redux'
import { selectPrevFullRouteNonPageLess } from '../../store/history/history.selectors'
import useKeycloak from './useKeycloak'

const UserLoginButton = ({ size = SIZE_BIG }) => {
  const { loaded, keycloak } = useKeycloak()
  const lastFullRoute = useSelector(selectPrevFullRouteNonPageLess)

  if (!loaded) return <></>

  const loginUrl = keycloak.createLoginUrl({ redirectUri: `${location.origin}${lastFullRoute}` })

  return (
    <RectangleActionButton
      tagData={{ type: TAG_CLICK_USER_LOGIN_BUTTON }}
      nofollow
      size={size}
      label="Connexion / Inscription"
      href={loginUrl}
    />
  )
}

export default withUserKnown(UserLoginButton)
